/*
 * @Author: dipub_shjy
 * @Date: 2019-10-14 11:33:56
 * @LastEditors: shijy
 * @LastEditTime: 2023-06-14 16:45:54
 * @Description: H5本地存储
 */

const EXPIRED_DAY = 1 // 一天失效
if (typeof window.localStorage == "undefined") {
    alert("非常遗憾，浏览器不支持localstorage,程序大概率是不能正常运行了")
}
export function saveCache(nameSpace,value,expire){

    try{
        window.localStorage.removeItem(nameSpace)
    }catch(err){

    }
    let storage = window.localStorage
    let now = new Date().getTime()
    now = parseInt(now / 1000)
    let expiredAt = now + EXPIRED_DAY * 24 * 60 * 60
    if('undefined' != typeof expire){
        expiredAt = now + expire
    }
    let data = {
        _value: value,
        _expiredAt: expiredAt
    }
    let d = JSON.stringify(data)
    storage.setItem(nameSpace, d)
    return true
}
export function getCache(namespace){
    let storage = window.localStorage
    let json = storage.getItem(namespace)
    let data = JSON.parse(json)
    let now = new Date().getTime()
    now = parseInt(now / 1000)
    let expiredAt = now
    if(null == data){
        return false
    }
    // 过期时间后延一天
    if (expiredAt < data._expiredAt) {
        let expiredAt = now + EXPIRED_DAY * 24 * 60 * 60
        data._expiredAt = expiredAt
        let d = JSON.stringify(data)
        storage.setItem(namespace, d)
        return data._value
    }
    return false
}
export function removeCache(namespace){
    window.localStorage.removeItem(namespace)
    return true
}
export function clear(){
    window.localStorage.clear()
}
const all = {
    saveCache,
    getCache,
    removeCache,
    clear
}
export default all